import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { nomeCompleto } from '@adega/shared';
import { CamposDoVinho } from '../components/CamposDoVinho.js';
import { ErrorBox, Loading } from '../components/Feedback.js';
import { PageHeader } from '../components/PageHeader.js';
import { useBottle, useUpdateBottle } from '../api/queries.js';
import {
  dadosDoFormulario,
  formularioDaGarrafa,
  type Formulario,
} from '../lib/formularioGarrafa.js';

/**
 * Corrigir os dados de uma garrafa: o que a leitura do rótulo errou ou não achou.
 *
 * Só os dados do vinho. Posição tem o próprio fluxo ("Mover", no detalhe), e
 * foto não se edita — cadastro com a foto errada se exclui e refaz.
 */
export function EditBottle() {
  const { id } = useParams();
  const bottleId = Number(id);
  const navigate = useNavigate();

  const { data: bottle, isLoading, error } = useBottle(bottleId);
  const atualizar = useUpdateBottle(bottleId);
  const [form, setForm] = useState<Formulario | null>(() => (bottle ? formularioDaGarrafa(bottle) : null));

  // Garrafa que ainda não estava no cache: preenche quando chega. Uma vez só —
  // uma nova busca em segundo plano não pode apagar o que a pessoa já digitou.
  useEffect(() => {
    if (bottle && form === null) setForm(formularioDaGarrafa(bottle));
  }, [bottle, form]);

  if (isLoading) return <Loading />;
  if (error || !bottle || !form) {
    return (
      <div>
        <PageHeader titulo="Editar garrafa" voltar />
        {error ? <ErrorBox erro={error} /> : null}
      </div>
    );
  }

  const definir = (campo: keyof Formulario, valor: string) =>
    setForm((atual) => (atual ? { ...atual, [campo]: valor } : atual));

  const salvar = async () => {
    await atualizar.mutateAsync(dadosDoFormulario(form));
    navigate(`/garrafa/${bottleId}`, { replace: true });
  };

  const semNome = form.name.trim().length === 0;

  return (
    <div className="space-y-4">
      <PageHeader titulo="Editar garrafa" subtitulo={nomeCompleto(bottle)} voltar />

      <section className="card space-y-3">
        <CamposDoVinho form={form} definir={definir} />
      </section>

      {atualizar.error ? <ErrorBox erro={atualizar.error} /> : null}

      <div className="sticky bottom-[calc(4rem+env(safe-area-inset-bottom)+0.5rem)] z-10 -mx-1 grid grid-cols-2 gap-2 rounded-2xl border border-adega-border bg-adega-bg/95 p-2 backdrop-blur">
        <button type="button" className="btn-secondary py-3" onClick={() => navigate(-1)}>
          Cancelar
        </button>
        <button
          type="button"
          className="btn-primary py-3"
          disabled={atualizar.isPending || semNome}
          onClick={() => void salvar()}
        >
          {atualizar.isPending ? 'Salvando…' : 'Salvar'}
        </button>
      </div>
    </div>
  );
}
